export const SEARCH_DOMESTIC_PAGE_NAME = {
  /** 서브홈 - 모텔 PLP */
  MOTEL: 'MOTEL',
  /** 서브홈 - 호텔 PLP */
  HOTEL: 'HOTEL',
  /** 서브홈 - 펜션 PLP */
  PENSION: 'PENSION',
  /** 서브홈 - 게스트하우스 PLP */
  GUESTHOUSE: 'GUESTHOUSE',
  /** 지역 PLP (공통상권) */
  AREA: 'AREA',
  /** 내주변 PLP */
  AROUND: 'AROUND',
  /** SRP */
  KEYWORD: 'KEYWORD',
} as const;

export type TSearchDomesticPageName = typeof SEARCH_DOMESTIC_PAGE_NAME[keyof typeof SEARCH_DOMESTIC_PAGE_NAME];

export const SEARCH_DOMESTIC_TYPE = {
  /** 모텔 서브홈 - 야놀자 초이스 */
  TOP: 'top',
  /** 모텔 서브홈 - 선착순 쿠폰 (내주변PLP) */
  RECOMMEND_MOTEL: 'recommendMotel',
  /** 전체 */
  ALL: 'all',
  /** 선착순 쿠폰 */
  RECOMMEND: 'recommend',
  /** 모텔 */
  MOTEL: 'motel',
  /** 호텔 */
  HOTEL: 'hotel',
  /** 펜션 */
  PENSION: 'pension',
  /** 게스트하우스 */
  GUESTHOUSE: 'guestHouse',
  /** #부티크브랜드 */
  BOUTIQUE: 'boutique',
  /** #프리미엄펜션 */
  PREMIUM_PENSION: 'premiumPension',
  /** #신축/리모델링 */
  CONSTRUCT: 'construct',
  /** #추천리조트 */
  RESORT: 'resort',
  /** #오션뷰호텔 */
  OCEAN_VIEW_HOTEL: 'oceanViewHotel',
  /** #조식제공 (호텔PLP) */
  BREAKFAST_HOTEL: 'breakfastHotel',
  /** #조식제공 (게스트하우스PLP) */
  BREAKFAST_GUESTHOUSE: 'breakfastGuestHouse',
  /** #수영장호텔 */
  POOL_HOTEL: 'poolHotel',
  /** #초특가호텔 */
  HOT_DEAL: 'hotDeal',
  /** #파티룸 */
  PARTY_ROOM: 'partyRoom',
  /** #풀빌라 */
  POOL_VILLA: 'poolVilla',
  /** #스파펜션 */
  SPA_PENSION: 'spaPension',
  /** #독채펜션 */
  ISOLATE_PENSION: 'isolatePension',
  /** #개별바베큐 */
  BARBECUE_PENSION: 'barbecuePension',
  /** #한옥 */
  HANOK: 'hanok',
  /** #투어/체험 */
  TOUR_GUESTHOUSE: 'tourGuestHouse',
  /** #커플룸 */
  COUPLE_GUESTHOUSE: 'coupleGuestHouse',
  /** #파티가능 */
  PARTY_GUESTHOUSE: 'partyGuestHouse',
} as const;

export type TSearchDomesticType = typeof SEARCH_DOMESTIC_TYPE[keyof typeof SEARCH_DOMESTIC_TYPE];
